import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { calculateTotalScore, removeSlashes } from '../../../utils/utils';
import HeaderContent from './headerContent/HeaderContent';
import PointsScore from '../shared/pointsScore/PointsScore';
import TitlePages from '../shared/titlePages/TitlePages';
import UserProfile from '../shared/userProfile/UserProfile';
import pathRouts from '../../../enums/pathRoute';
import classes from './Header.module.css';

const Header = () => {

    const { pathname } = useLocation();
    const gamification = useSelector((state) => state.gamification);
    const { isStudent } = useSelector(state => state.auth);
    const isHome = removeSlashes(pathname) === pathRouts.HOME.route;

    return (
        <div className={classes.Header}>
            <TitlePages pathname={!isHome ? pathname : null} />
            {/* {isStudent && <HeaderContent />} */}
            <div className={classes.PrivateArea}>
                {/* <PointsScore score={calculateTotalScore(gamification?.providers, "score")} /> */}
                <UserProfile />
            </div>
        </div>
    )
}

export default Header;